import type { AuthorInfo } from "@serophin/nottldr-shared";
import { INITIAL_BG, levelStyle } from "./levelStyles";

export type AuthorProfileImageProps = {
  author: AuthorInfo;
  size?: "xs" | "sm";
  class?: string;
};

const IMAGE_SIZES = { xs: "w-6 h-6", sm: "w-8 h-8" };
const FONT_SIZES = { xs: "text-xs", sm: "text-sm" };

const THUMBNAIL_PX = "64";

/** A small version of the picture: Unsplash is asked for one, and the logo has its own 64px file. */
const thumbnailOf = (source: string): string => {
  const url = new URL(source);
  if (url.hostname.endsWith("unsplash.com")) {
    url.searchParams.set("w", THUMBNAIL_PX);
    url.searchParams.set("fm", "avif");
    url.searchParams.set("q", "50");
    return url.toString();
  }
  if (url.hostname.endsWith("nottldr.com") && source.endsWith("nottldr_logo_black.jpg")) {
    return source.replace("nottldr_logo_black.jpg", "nottldr_logo_black_64.jpg");
  }
  return source;
};

export const AuthorProfileImage = ({ author, size = "xs", class: className = "" }: AuthorProfileImageProps) => {
  const border = levelStyle(author.targetAudience.expertise).border;
  const sizeClass = IMAGE_SIZES[size];

  if (author.profileImage?.src) {
    return (
      <div>
        <img
          src={thumbnailOf(author.profileImage.src)}
          alt={author.profileImage.alt || `${author.alias} profile`}
          class={`rounded-full border-2 object-cover ${sizeClass} ${border} ${className}`}
        />
      </div>
    );
  }

  return (
    <div>
      <div
        class={`rounded-full flex items-center justify-center ${INITIAL_BG} text-white font-bold border-2 ${sizeClass} ${border} ${FONT_SIZES[size]} ${className}`}
      >
        {author.alias.charAt(0).toUpperCase()}
      </div>
    </div>
  );
};
